<template>
  <div class="HtmlPanel" v-if="iframeUrl">
    <iframe :class="iframeId" :id="iframeId" ref="iframe" scrolling="no" border="0" frameborder="no"
            :style="{height:iframeHeight+'px',width:'100%'}"></iframe>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueResource from 'vue-resource';
  Vue.use(VueResource);
  export default {
    name: 'HtmlPanel',
    data: function () {
      var vm = this;
      return {
        loading: false,
        html: '',
        iframeHeight: 0,
        iframeUrl: null,
        clientWidth: document.documentElement.clientWidth > 500 ? 500 : document.documentElement.clientWidth,
        previewImgList:[]
      }
    },
    props: {
      url: {
        type: String,
        required: true,
        default: ''
      },
      iframeId: {
        type: String,
        required: false,
        default: 'iframeId'
      },
    },
    //不同活动的处理
    watch: {
      url: {
        immediate: true,
        handler(value) {
          var vm = this;
          console.log(value);
          vm.iframeUrl = value;
          if(vm.iframeUrl){
            vm.clientWidth = document.documentElement.clientWidth > 500 ? 500 : document.documentElement.clientWidth;
            vm.iframeHeight = 0;
            vm.load();
          }
        },
      },
    },
    //同一场活动的处理
    activated(){
      var vm = this;
      vm.iframeUrl = vm.url;
      if(vm.iframeUrl){
        vm.clientWidth = document.documentElement.clientWidth > 500 ? 500 : document.documentElement.clientWidth;
        vm.iframeHeight = 0;
        vm.load();
      }
    },
    methods: {
      replaceImgUrl: function (url) {
        if (url) {
          url = url.replace(new RegExp("http://", 'g'), "https://");
        }
        return url;
      },
      load: function () {
        var vm = this;
        var url = vm.replaceImgUrl(vm.iframeUrl);
        if (url && url.length > 0) {
          vm.loading = true;
          let param = {
            ContentType: 'text/html, text/plain',
            CacheControl: 'max-age=999999999',
            name: 'referrer'
          };
          vm.$http.get(url, param).then((response) => {
            vm.loading = false;
            const iframe = document.getElementsByClassName(vm.iframeId)[0];
            const iframedoc = iframe.contentDocument || iframe.contentWindow.document;
            var ihtmlStr = "<header><meta name='viewport' content='width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no'>" +
              "<style>img{max-width:100%};p,a,span{white-space:normal!important;word-break:break-all!important;word-wrap:break-word!important;}</style>" +
              "</header>" + response.data;
            ihtmlStr = ihtmlStr.replace(new RegExp("http://", 'g'), "https://");
            ihtmlStr = ihtmlStr.replace(new RegExp("white-space: pre;", 'g'), "");
            ihtmlStr = ihtmlStr.replace(new RegExp("white-space:pre;", 'g'), "");
            iframedoc.children[0].innerHTML = ihtmlStr; // 事先拿到的html
            // 处理HTML显示
            vm.$nextTick(() => {
              vm.iframeHeightFun(iframedoc);
            })
          }).catch(() => {
            vm.loading = false;
            vm.html = '加载失败'
          })
        }
      },
      iframeHeightFun: function (iframedoc) {
        var vm = this;
        var num = 0;
        //先请求接口后再进入页面
        setTimeout(function () {
          vm.IntervalStr = setInterval(setIntervalFun, 1);
        }, 50);
        let setIntervalFun = function () {
          if (num < 10000) {
            vm.getHeight();
            num++;
            setIntervalFun();
          } else {
            clearInterval(vm.IntervalStr);
            //预防加载慢
            setTimeout(function () {
              vm.timer();
            }, 20)
          }
        };
        vm.getHeight = function () {
          var iframeHeight = iframedoc.children[0].scrollHeight;
          if (vm.iframeHeight < iframeHeight) {
            vm.iframeHeight = iframeHeight;
          }
        };
        vm.timer = function () {
          vm.getHeight();
          setTimeout(function () {
            vm.getHeight();
          }, 1000)
        };

      }
    },
    beforeDestroy(){
      this.iframeUrl = null;
    },
  }
</script>




// WEBPACK FOOTER //
// src/components/HtmlPanel.vue